var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEmpty(_vm.coachByUuid(_vm.coachesUuid)))?_c('CSpinner',{attrs:{"color":"primary"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }